export const firebaseConfig = {
  apiKey: "AIzaSyDtDDvxE0JuGY_eksY7cbprlN_zKIEzC_I",
  authDomain: "true-colors-991bb.firebaseapp.com",
  projectId: "true-colors-991bb",
  storageBucket: "true-colors-991bb.appspot.com",
  messagingSenderId: "580095287994",
  appId: "1:580095287994:web:0ea9731230ef1f5db8d883",
};
